export const AXIOS_NETWORK_ERROR = 'Network Error';

// API endpoints
export const API_BASE_PATH = '/portal/api/v1';
export const DEVICE_ADAPTER_API_BASE_PATH = '/device-adapter/api/v1';

// Portal fallback formats
export const DEFAULT_PORTAL_PATIENT_ID_FORMAT = '^.+$';
export const DEFAULT_PORTAL_PATIENT_BARCODE_FORMAT = '^.+$';
export const DEFAULT_PATIENT_BARCODE_TYPE = 'ALL';

// Frontend barcode-format strings
// The serial is base36, not hex: the manufacturer generates the batch/random part with
// the full 0-9a-z alphabet, so letters beyond f occur. Uppercase is accepted as well.
const HEALTHDOT_SERIAL_PATTERN = '[0-9A-Za-z]{16}';
export const HEALTHDOT_DEVICE_BARCODE_FORMAT = `^HD5/${HEALTHDOT_SERIAL_PATTERN}$`;
const VIQTOR_SERIAL_PATTERN = '[A-Za-z0-9-]{4,40}';
export const VIQTOR_UDI_DEVICE_BARCODE_FORMAT = `^.*\\(21\\)${VIQTOR_SERIAL_PATTERN}.*$`;

// HealthDot device identifier patterns.
// The prefix says which device family a scanned code belongs to; the serial pattern says
// whether the identifier behind it is readable. Keeping those two questions apart lets an
// unreadable HealthDot report itself as a HealthDot with a bad ID, instead of falling
// through to "unknown device" and producing an error about the wrong thing.
export const HEALTHDOT_CODE_PREFIX = 'HD5/';
export const HEALTHDOT_CODE_PREFIX_REGEX = new RegExp(`^${HEALTHDOT_CODE_PREFIX}`, 'i');
export const HEALTHDOT_CODE_REGEX = new RegExp(`^HD5\\/${HEALTHDOT_SERIAL_PATTERN}$`, 'i');
export const HEALTHDOT_SERIAL_REGEX = new RegExp(`^${HEALTHDOT_SERIAL_PATTERN}$`, 'i');

// viQtor device identifier patterns
// UDI format: "(21)SERIAL" - capture group can extract the serial part
export const VIQTOR_UDI_REGEX = new RegExp(`\\(21\\)(${VIQTOR_SERIAL_PATTERN})`, 'i');
// Serial-only format validation: standalone serial code (no prefix)
export const VIQTOR_SERIAL_REGEX = new RegExp(`^${VIQTOR_SERIAL_PATTERN}$`, 'i');
